
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.443 17.208a1.935 1.935 0 01-1.374-.57 1.956 1.956 0 01-.569-1.373v-5.138a1.944 1.944 0 011.59-1.911V6.7a3.909 3.909 0 017.818 0v1.522a1.913 1.913 0 011.022.53 1.936 1.936 0 01.57 1.374v5.139a1.959 1.959 0 01-.57 1.374 1.937 1.937 0 01-1.372.569zm6.074-9.024V6.7a2.518 2.518 0 10-5.035 0v1.484z"}})])
          )
        }
      }
    